<template>
  <div class="app-header">
    <h5 v-if="isZealandFlow">Excelerate - gratis for alle studerende</h5>
    <h5 v-else>Excelerate - free to use for students</h5>
  </div>
</template>

<script>
export default {
    name: 'StudentHeader',
    computed: {
      isZealandFlow() {
        return this.$store.getters.isZealandFlow
      },
    }
}
</script>

<style>
.app-header{
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    /* top: 54px; */
    background: transparent linear-gradient(270deg, #BC1E73 0%, #5A2871 100%) 0% 0% no-repeat padding-box;
    z-index: 9999; /* because of another element   */
}
@media (max-width: 768px) {
.app-header{
  /* top: 70px; */
}
}
@media (max-width: 499px) {
.app-header{
  /* top: 98px; */
}
}
.app-header h5 {
color: #fff;
margin:10px;
font-weight: 200;
font-size: 13px;
text-align: center;
}
/* .app-header h5{ 
    color: #fff;
    margin: 10px;
    font-weight: 400;
    font-size: 15px;
    text-align: center;
} */
</style>